import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GroupDatesService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getGroupDates(obj: any): Observable<any> {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.get(this.baseUrl + 'getGroupDates', httpOptions);
  }

  createGroupDate(data: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.post(`${this.baseUrl}createGroupDate`, data, httpOptions);
  }

  updateGroupDate(data: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.patch(`${this.baseUrl}updateGroupDate`, data, httpOptions);
  }

  deleteGroupDate(id: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.delete(
      `${this.baseUrl}deleteGroupDate/${id}`,
      httpOptions
    );
  }

  confirmGroupDate(id: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.patch(
      `${this.baseUrl}confirmGroupDate/${id}`,
      {},
      httpOptions
    );
  }

  getGroupDateApplicants(obj: any): Observable<any> {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.get(
      `${this.baseUrl}getGroupDateApplicants/${obj.id}`,
      httpOptions
    );
  }

  updateAttendeeOrder(obj: any): Observable<any> {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.patch(
      `${this.baseUrl}updateAttendeeOrder`,
      obj,
      httpOptions
    );
  }

  updateAttendeeStatus(obj: {
    group_date_id: string;
    user_id: string;
    status: string;
  }): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.patch(
      `${this.baseUrl}updateAttendeeStatus`,
      {
        group_date_id: obj.group_date_id,
        attendee_id: obj.user_id, // using attendee_id instead of user_id, as in backend user_id is for admin's id
        status: obj.status,
      },
      httpOptions
    );
  }

  // Search for users to add to waitlist
  searchUsersForWaitlist(obj: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.post(
      `${this.baseUrl}searchUsersForWaitlist`,
      obj,
      httpOptions
    );
  }

  // Add users to waitlist
  inviteUserToDate(obj: {
    group_date_id: string;
    user_ids: string[];
    gender: string;
  }): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.post(
      `${this.baseUrl}inviteAttendeeToGroupDate/${obj.group_date_id}`,
      obj,
      httpOptions
    );
  }

  // Update group date applicant status
  updateGroupDateApplicantStatus(obj: {
    group_date_id: string;
    user_id: string;
    status: string;
  }): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.patch(
      `${this.baseUrl}updateGroupDateApplicantStatus`,
      obj,
      httpOptions
    );
  }

  // Remove group date applicant
  removeGroupDateApplicant(obj: {
    group_date_id: string;
    user_id: string;
  }): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.delete(
      `${this.baseUrl}removeGroupDateApplicant/${obj.group_date_id}/${obj.user_id}`,
      httpOptions
    );
  }

  // Confirm attendee invites
  confirmAttendeeInvites(groupDateId: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.patch(
      `${this.baseUrl}confirmAttendeeInvites/${groupDateId}`,
      {},
      httpOptions
    );
  }

  // Update group date status
  updateGroupDateStatus(groupDateId: string, status: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        accessToken: localStorage.getItem('token') || '',
      }),
    };
    return this.http.patch(
      `${this.baseUrl}updateGroupDateStatus/${groupDateId}`,
      { status: status },
      httpOptions
    );
  }
}
